import type { DossierNote } from './types';

// MIME custom encodant le scope d'une note (pdf_file_id + page_number).
// Utilisé pendant `dragover` pour refuser le drop hors scope (UX décision
// D : désactivation visuelle, pas de déplacement cross-pièce/page).
export function noteScopeMime(note: DossierNote): string {
  return `application/x-adr-note-scope-${note.pdf_file_id ?? 'none'}-${note.page_number ?? 0}`;
}
